<template>
    <div>
        <div class="image_box">
            <div class="block" v-if="['SUCCESS', 'FAILURE'].includes(item.status)">
                <template v-if="(item.imageUrls || []).length <= 1">
                    <el-image @click.stop.prevent="clickImage" :src="(item.imageUrls && item.imageUrls[0]) || ''" :preview-src-list="item.imageUrls" style="width: 168px; height: 168px;"
                        fit="contain">
                        <div slot="placeholder" class="image-slot">
                            加载中<span class="dot">...</span>
                        </div>
                        <div slot="error" class="image-slot">
                            <i class="el-icon-picture-outline"></i>
                        </div>
                    </el-image>
                </template>
                <div v-else class="multi-grid">
                    <el-image
                        v-for="(url, idx) in item.imageUrls"
                        :key="idx"
                        @click.stop.prevent="clickImage"
                        :src="url"
                        :preview-src-list="item.imageUrls"
                        style="width: 80px; height: 80px"
                        fit="cover">
                        <div slot="placeholder" class="image-slot">
                            加载中<span class="dot">...</span>
                        </div>
                        <div slot="error" class="image-slot">
                            <i class="el-icon-picture-outline"></i>
                        </div>
                    </el-image>
                </div>
            </div>
            <div class="block" v-else>
                <Spin fix>
                    <Icon type="ios-loading" size=50 class="demo-spin-icon-load"></Icon>
                </Spin>
            </div>
            <div class="block1">
                <Row :gutter="0" style="margin-bottom: 5px;">
                    <Col span="24" >
                        <Tag style="font-size: 12px;" v-if="item.status == 'NOT_START'">未开始</Tag>
                        <Tag color="purple" style="font-size: 12px;" v-if="item.status == 'SUBMITTED'">已提交</Tag>
                        <Tag color="primary" style="font-size: 12px;" v-if="item.status == 'IN_PROGRESS'">生成中</Tag>
                        <Tag color="success" style="font-size: 12px;" v-if="item.status == 'SUCCESS'">完成</Tag>
                        <Tag color="error" style="font-size: 12px;" v-if="item.status == 'FAILURE'">失败</Tag>

                        <Button v-if="item.status == 'FAILURE'" size="small" style="margin-right: 5px;font-size: 12px;" @click="modal2=true">原因</Button>
                        <Button size="small" style="margin-right: 5px;font-size: 12px;" @click="handleShowDesc">描述</Button>
                        <Button size="small" style="margin-right: 5px;font-size: 12px;" @click="handleDelete(item.id)">删除</Button>
                    </Col>
                    <Col span="24" >
                        <Button v-if="item.status == 'SUCCESS'" size="small" style="margin-right: 5px;font-size: 12px;" @click="handleAddToPreview(item)">选为参考图</Button>
                        <Button v-if="item.status == 'SUCCESS'" type="primary" size="small" style="margin-right: 5px;font-size: 12px;" @click="handleSetAsAdImage">设为广告图</Button>
                    </Col>
                </Row>
            </div>
        </div>
        <Modal
			width="500"
			v-model="modal2"
			title="失败原因"
			:footer-hide="true">
            {{ item.failReason }}
		</Modal>
        <Modal
            width="600"
            v-model="modalDesc"
            title="生成详情"
            :footer-hide="true">
            <div style="text-align: left;">
                <h4 style="margin-bottom:8px;">参考图</h4>
                <div v-if="detailImageUrls.length">
                    <el-image
                        v-for="(url, idx) in detailImageUrls"
                        :key="idx"
                        @click.stop.prevent="clickImage"
                        :src="url"
                        :preview-src-list="detailImageUrls"
                        style="width: 126px; height: 126px;margin-right: 10px;"
                        fit="contain">
                        <div slot="placeholder" class="image-slot">
                            加载中<span class="dot">...</span>
                        </div>
                        <div slot="error" class="image-slot">
                            <i class="el-icon-picture-outline"></i>
                        </div>
                    </el-image>
                </div>
                <div v-else style="color:#888;margin-bottom:10px;">无图片</div>

                <h4 style="margin:12px 0 8px;">详细信息</h4>
                <ul class="desc-list">
                    <li>提示词：{{ displayPrompt(detail) }}</li>
                    <li>分辨率：{{ displayResolution(detail) }}</li>
                    <li>宽高比：{{ displayRatio(detail) }}</li>
                    <li>模型：{{ displayModel(detail) }}</li>
                </ul>
            </div>
        </Modal>
    </div>
</template>

<script>
import downLoadRemoteFile from '@/util/downLoadRemoteFile';
export default {
    components: {
	},
    props: {
        item: {
            type: [Object],
            default: {}
        },
    },
    data() {
        return {
            modal: false,
            modal1: false,
            modal2: false,
            modalDesc: false,
            detail: { properties: { image_urls: [] }, imageUrls: [] },
            action: 'IMAGINE',
            status: 'SUCCESS',
            prompt: '',
            promptEN: '',
            promptENArr: [],
            properties: []
        }
    },
    computed: {
        detailImageUrls(){
            const d = this.detail || {}
            const props = (d && d.properties) || {}
            const image_urls = props.image_urls || props.refer_images || []
            return image_urls
        }
    },
    methods: {
        handleSetAsAdImage(){
            const url = (this.item.imageUrls && this.item.imageUrls[0]) || ''
            if (!url) return
            const props = (this.item && this.item.properties) || {}
            const meta = { selected_placement: props.selected_placement, width: props.width, height: props.height }
            this.$emit('setAsAdImage', url, meta)
        },
        handleUpscale(value) { this.$emit('change:u', value); },
        handleValiation(value) { this.$emit('change:v', value); },
        handleReroll(value) { this.$emit('change:r', value); },
        handlePan(value) { this.$emit('change:pan', value); },
        handleZoomOut(value) { this.$emit('change:zoom', value); },
        handleVaryRegion(value, src){ this.$emit('change:vary_region', value, src); },
        handleEditSize(src){ this.$emit('change:edit_size', src); },
        handleDelete(value) { this.$emit('change:d', value); },
        handleReflash(value) { this.$emit('reflash', value); },
        handleOpenChange(value) { this.$emit('openChange', value); },
        handleShowPrompts(item) {
            this.action = item.action
            this.status = item.status
            this.prompt = item.prompt
            this.promptEN = item.promptEN
            if (this.promptEN){ this.promptENArr = this.promptEN.split('\n\n') }
            this.properties = item.properties
            this.modal = true
        },
        clickImage() {
            this.$nextTick(() => {
                let wrapper = document.getElementsByClassName('el-image-viewer__actions__inner');
                let downImg = document.createElement('i');
                downImg.setAttribute('class', 'el-icon-download');
                wrapper[0].appendChild(downImg);
                if (wrapper.length > 0) {
                    this.wrapperElem = wrapper[0];
                    this.downImg = downImg
                    this.cusClickHandler();
                }
            });
        },
        cusClickHandler() {
            this.downImg.addEventListener('click', () => {
                const imgUrl = document.getElementsByClassName('el-image-viewer__img')[0].src;
                const filename = imgUrl.split('/').pop();
                downLoadRemoteFile(imgUrl, filename);
            });
        },
        handleShowDesc(){ this.detail = this.item || {}; this.modalDesc = true },
        handleAddToPreview(item){ this.$emit('addPreview', item.imageUrls) },
        displayResolution(obj){ const props = (obj && obj.properties) || {}; return obj.selected_resolution || props.selected_resolution || '-' },
        displaySize(obj){ const props = (obj && obj.properties) || {}; const w = obj.width || props.width; const h = obj.height || props.height; if (w && h) return `${w}×${h}`; const size = obj.size || props.size; return size ? `${size}` : '-' },
        displayRatio(obj){ const props = (obj && obj.properties) || {}; return obj.selected_ratio || props.selected_ratio || props.aspect_ratio || '-' },
        displayModel(obj){ const props = (obj && obj.properties) || {}; if (obj.model === 'jimeng') return '即梦'; return props.model || obj.model || '-' },
        displayPrompt(obj){ const props = (obj && obj.properties) || {}; return obj.prompt || props.prompt || '-' },
    }
}
</script>

<style>
.image_box{ width: 180px; height: 250px; border:1px solid #eee; box-sizing:border-box; padding:6px; position:relative; background:#fff; }
.block{ width:168px; height:168px; overflow:hidden; position: relative; }
.block1{ position:absolute; bottom:5px; left:5px; right:5px; }
.image-slot{ display:flex; align-items:center; justify-content:center; width:100%; height:100%; color:#888; }
.multi-grid{ display:flex; flex-wrap:wrap; gap:6px; }
.demo-spin-icon-load{ animation: ani-demo-spin 1s linear infinite; }
@keyframes ani-demo-spin{ 0%{ transform: rotate(0deg);} 100%{ transform: rotate(360deg);} }
.desc-list{ list-style:none; padding:0; margin:0; }
.desc-list li{ margin-bottom:6px; }
</style>



// WEBPACK FOOTER //
// src/components/common/show_jimeng_image.vue